var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mod_call"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"content"},[_c('p',{staticClass:"tips"},[_vm._v(" 我的魂力 "),_c('span',{staticClass:"num"},[_vm._v(_vm._s(_vm.myPropsNum))]),_vm._v(" 快去购票获得魂力吧！ ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }